module.exports = __webpack_public_path__ + "media/images/icons/da_assegnare_verifica-2b5afd10563742cb3c07fac5bb7a8f79.svg";